import axios from 'api/api.config';
import qs from 'query-string';
import { useMutation } from 'react-query';

export function useExportAnalyticPresensi() {
  return useMutation(({ queryFilter, bodyFilter }) =>
    axios.post(`/api/v1/admin/attendance/export?${qs.stringify(queryFilter)}`, bodyFilter).then((res) => res.data)
  );
}
